module.exports = __webpack_public_path__ + "static/img/frontpage6.da8d891.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/image/frontpage6.png
// module id = 0xZ6
// module chunks = 0